import {startOfWeek, subWeeks, addDays, isWithinInterval} from 'date-fns';
import {Colors} from 'src/styles';

export const serviceTypesMap = {
  direct: {
    title: 'Direct Treatment',
    color: Colors.SECONDARY_800,
  },
  clinical: {
    title: 'Clinical Services',
    color: Colors.TEAL_500,
  },
};

const isValidCPT = (cpt: string) => cpt && cpt !== '00000';

export const calculateWeeklyServiceHours = (sessions: any[]) => {
  const now = new Date();
  const weeks: {
    week: string;
    start: Date;
    end: Date;
    total: number;
    direct: number;
    clinical: number;
    directCPTs: Set<string>;
    clinicalCPTs: Set<string>;
  }[] = [];

  for (let i = 11; i >= 0; i--) {
    const start = startOfWeek(subWeeks(now, i), {weekStartsOn: 0});
    const end = addDays(start, 7);
    weeks.push({
      week: start.toISOString().split('T')[0],
      start,
      end,
      total: 0,
      direct: 0,
      clinical: 0,
      directCPTs: new Set(),
      clinicalCPTs: new Set(),
    });
  }

  for (const session of sessions) {
    const {editedStartTimestamp, editedEndTimestamp, cpt} = session;
    if (
      !Array.isArray(cpt) ||
      cpt.length === 0 ||
      cpt.every(code => code === '00000')
    ) {
      continue;
    }

    const start = new Date(editedStartTimestamp);
    const end = new Date(editedEndTimestamp);
    const durationHours = (end.getTime() - start.getTime()) / 3600000;
    if (durationHours <= 0.01) {
      continue;
    }

    for (const week of weeks) {
      if (isWithinInterval(start, {start: week.start, end: week.end})) {
        week.total += durationHours;

        if (cpt.includes('97153')) {
          week.direct += durationHours;
          cpt.forEach(code => {
            if (code === '97153') {
              week.directCPTs.add(code);
            }
          });
        } else {
          cpt.forEach(code => {
            if (isValidCPT(code)) {
              week.clinical += durationHours;
              week.clinicalCPTs.add(code);
            }
          });
        }

        break;
      }
    }
  }

  return weeks.map(w => ({
    week: w.week,
    total: Number(w.total.toFixed(2)),
    direct: Number(w.direct.toFixed(2)),
    clinical: Number(w.clinical.toFixed(2)),
    directPercent: w.total ? Math.round((w.direct / w.total) * 100) : 0,
    clinicalPercent: w.total ? Math.round((w.clinical / w.total) * 100) : 0,
    directCPTs: Array.from(w.directCPTs),
    clinicalCPTs: Array.from(w.clinicalCPTs),
  }));
};
